// FileNameModal.js
import React, { useState } from 'react';
import { Button, Modal, Form } from 'react-bootstrap';

function FileNameModal({ show, onHide, onSubmit }) {
    const [fileName, setFileName] = useState('');

    const handleFileNameChange = (e) => {
        setFileName(e.target.value);
    };

    const handleButtonClick = () => {
        onSubmit(fileName);
        setFileName('');
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title className='text-info' id="contained-modal-title-vcenter">
                    Enter File Name
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className='px-5 py-3'>
                <Form>
                    <Form.Group controlId="fileName">
                        <Form.Label>File Name</Form.Label>
                        <Form.Control 
                            type="text" 
                            value={fileName} 
                            onChange={handleFileNameChange} 
                        />
                    </Form.Group>
                </Form>
                <div className='mt-3 d-flex justify-content-end'>
                    <Button variant='primary' size='lg' className='' onClick={handleButtonClick}>Save</Button>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default FileNameModal;
